<template>
  <v-dialog :value="value" @input="$emit('input', $event)">
    <v-card>
      <v-simple-table style="width:100%;">
        <template v-slot:default>
          <thead>
            <tr class="yellow lighten-3">
              <th style="border-bottom:0"></th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>Your Data</strong>
              </th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>P10</strong>
              </th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>P25</strong>
              </th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>P50</strong>
              </th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>P75</strong>
              </th>
              <th style="border-bottom:0" class="text-xs-left">
                <strong>P90</strong>
              </th>
              <!-- <th class="text-xs-left">
            <strong>Mean</strong>
          </th> -->
              <th style="border-bottom:0" class="text-xs-left">
                <strong
                  >% Delta with
                  <v-menu bottom right>
                    <template v-slot:activator="{ on }">
                      <a v-on="on">{{ perSelected.text }}</a>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, i) in percentiles"
                        :key="i"
                        @click="perSelected = item"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(r, i) in rowsSummary">
              <tr
                :key="r.value + '1'"
                :class="{
                  'yellow lighten-4 black--text text--darken-3': i % 2 !== 0,
                  'yellow lighten-5 black--text text--darken-3': i % 2 === 0,
                }"
              >
                <td style="font-size:0.8rem;border-bottom:0;">
                  <v-tooltip top v-if="r.tip">
                    <template v-slot:activator="">
                      <strong>{{ r.text }} (p.a.)</strong>
                      <span>{{ r.tip }}</span>
                    </template>
                  </v-tooltip>
                  <strong v-if="!r.tip">{{ r.text }} (p.a.)</strong>
                </td>
                <td style="width:160px;font-size:0.8rem;border-bottom:0;">
                  <v-text-field
                    single-line
                    hide-details
                    type="number"
                    class="pb-1 pt-2"
                    row-height="18"
                    v-model="entries[i]"
                  ></v-text-field>
                </td>
                <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{ pval(benefits[r.value], 10) | currency }}
                </td>
                <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{ pval(benefits[r.value], 25) | currency }}
                </td>
                <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{ pval(benefits[r.value], 50) | currency }}
                </td>
                <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{ pval(benefits[r.value], 75) | currency }}
                </td>
                <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{ pval(benefits[r.value], 90) | currency }}
                </td>
                <!-- <td style="width:150px;font-size:0.8rem;border-bottom:0;">
                  {{mean(benefits[r.value])|currency}}</td> -->
                <td style="width:180px;font-size:0.8rem;border-bottom:0;" class="text-xs-center">
                  {{ deltas[i] | percentage }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions class="yellow lighten-2">
        <v-layout>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('input', false)" color="accent darken-3" text small>Close</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from 'vue';
import pval from '../util/pval';
import percentage from '../util/percentage';
import currency from '../util/currency';

export default Vue.extend({
  data() {
    return {
      entries: [],
      perSelected: { text: 'P50', value: 50 },
      percentiles: [
        { text: 'P10', value: 10 },
        { text: 'P25', value: 25 },
        { text: 'P50', value: 50 },
        { text: 'P75', value: 75 },
        { text: 'P90', value: 90 },
      ],
    };
  },
  watch: {
    value() {
      if (!this.value) {
        this.entries = [];
      }
    },
  },
  computed: {
    rowsSummary() {
      return this.rows.filter((r) => r.isSummary || r.value === 'salary');
    },
    deltas() {
      return this.rowsSummary.map((r, i) => {
        const entry = this.entries[i];
        if (typeof entry === 'undefined') return '';
        const p = this.pval(this.benefits[r.value], this.perSelected.value);
        return ((+this.entries[i] - p) / p) * 100;
      });
    },
  },
  methods: {
    pval,
    mean(array) {
      if (array === null || typeof array === 'undefined') {
        return '';
      }
      const sum = array.reduce((a, b) => a + b);
      return sum / array.length;
    },
  },
  filters: {
    percentage,
    currency,
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
    benefits: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
      type: Boolean,
    },
  },
});
</script>
<style scoped></style>
